import API from '@/api'

export default {
  namespaced: true,
  state: {
    data: [],
    loaded: false,
  },
  mutations: {
    saveData(state, data) {
      state.data = data;
    },
    load(state) {
      state.loaded = true;
    }
  },
  actions: {
    updateData(context, payload) {
      return API.fields.getFieldsAndFarms().then(res => {
        context.commit('saveData', res.data.data);
        context.commit('load');
      });

    }
  },
  getters: {
    data(state) {
      return state.data;
    },

    /**
     * работает
     * @param {*} state
     */
    fields(state) {
      const fields = [];
      state.data.forEach(n => {
        fields.push(...n.fields);
      });
      return fields;
    },

    farms(state) {
      return state.data;
    },

    getFarmById : state => id => {
      return state.data.find(n => n.id == id);
    },

    getFieldById : (state, getters) => id => {
      return getters.fields.find(n => n.id == id);
    },

    isLoaded(state) {
      return state.loaded;
    },

    fieldsLatLgnBounds(state, getters) {
      let fields = getters.fields;
      let LatLngs = [];

      fields.map(function(el) {
        for(let prop in el.coordinates) {
          let bounds = [ el.coordinates[prop].latitude, el.coordinates[prop].longitude ];
          bounds = Object.values(bounds)
          LatLngs.push(bounds);
        }
      });

      LatLngs = Object.values(LatLngs);

      return LatLngs;
    },

    getFarmsForSelector(state) {
      let data = state.data.map(function(el) {
        return {
          key : el.id,
          label : el.name,
          value : el.id,
        }
      } );
      return data;
    },

    getFieldsForSelector : state => farmId =>  {
      let farmFields = state.data.find(n => n.id === farmId)
      let data = farmFields.fields.map(function(el) {
        return {
          key : el.id,
          label : el.name,
          value : el.id,
        }
      } );
      return data;
    },
  }
}
